export default __webpack_public_path__ + "static/media/section4-img2.58a9fb27.png";